import React from 'react';
import config from 'config';
import {DocumentList} from 'components/documents';


export const UserDetailList = ({ user }) => (
  <DocumentList>
    <li>ПІБ: <strong>{user.get('user_data').get('first_name')} {user.get('user_data').get('middle_name')} {user.get('user_data').get('last_name')}</strong></li>
    <li>Електронна пошта: <strong>{user.get('user_data').get('email') ? user.get('email'): "Не вказана"}</strong></li>
    <li>Номер телефону: <strong>{user.get('phone') ? user.get('phone') : "Не вказаний"}</strong></li>
    <li>ID: <strong>{user.get('id')}</strong></li>
    {/* ffffffffffffffff */}
    <li>Активний: <strong>{user.get('is_active') ? (
      <i style={{color: "#edbd2f", fontSize: "24px"}} className="fa fa-check-circle" />
    ):(
      <i style={{color: "#dd4b39", fontSize: "24px"}} className="fa fa-times-circle-o" aria-hidden="true"></i>
    )}</strong></li>
    {/* sefdsssssssssssss */}
    <li>Персонал: <strong>{user.get('is_staff') ? (
      <i style={{color: "#edbd2f", fontSize: "24px"}} className="fa fa-check-circle" />
    ):(
      <i style={{color: "#dd4b39", fontSize: "24px"}} className="fa fa-times-circle-o" aria-hidden="true"></i>
    )}</strong></li>
    {/* awdadawd */}
    <li>Суперюзер: <strong>{user.get('is_superuser') ? (
      <i style={{color: "#edbd2f", fontSize: "24px"}} className="fa fa-check-circle" />
    ):(
      <i style={{color: "#dd4b39", fontSize: "24px"}} className="fa fa-times-circle-o" aria-hidden="true"></i>
    )}</strong></li>
    {/* sasefsdfsd */}
    {user.get('date_joined') ? (
       <li>Дата реєстрації: <strong>{new Date(user.get('date_joined')).toLocaleString('uk-UA', config.options)}</strong></li>
    ):(
      <li>Дата реєстрації: <strong>Не вказана</strong></li>
    )}
    <li>Останній логін: <strong>{user.get('last_login') ? new Date(user.get('last_login')).toLocaleString('uk-UA', config.options) : "Інформація відсутня"}</strong></li>
    <li>Коментар: <strong>{user.get('comment') ? user.get('comment') : "Відсутній"}</strong></li>
    <li>Логін: <strong>{user.get('user_data').get('username')}</strong></li>
  </DocumentList>
)



// WEBPACK FOOTER //
// ./src/admin/users/user-detail-list.js